import { Suspense, lazy } from 'react';
import { Navigate, useRoutes, useLocation } from 'react-router-dom';
// layouts
// import MainLayout from '../layouts/main';
import DashboardLayout from '../layouts/dashboard';

import LogoOnlyLayout from '../layouts/LogoOnlyLayout';
// guards
// import GuestGuard from '../guards/GuestGuard';
import AuthGuard from '../guards/AuthGuard';
// import RoleBasedGuard from '../guards/RoleBasedGuard';
// config
import { PATH_AFTER_LOGIN } from '../config';
// components
import LoadingScreen from '../components/LoadingScreen';




// ----------------------------------------------------------------------

const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();
  return (
    <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
      <Component {...props} />
    </Suspense>
  );
};

export default function Router() {
  return useRoutes([
    { path: '/', element: <Home /> },
    { path: '/login/admin', element: <Login /> },
    { path: '/codemail', element: <CodeMail /> },
    { path: '/login/company', element: <CompanyLogin /> },
    { path: '/login/clinic', element: <ClinicLogin /> },
    { path: '/forget', element: <Register /> },
    { path: '/subscription', element: <Subscription /> },
    { path: '/reset-passsword', element: <ResetPassword usertype={'company'} /> },
    { path: '/clinic-reset-passsword', element: <ResetPassword usertype={'clinic'} /> },
    {
      path: 'dashboard',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [

        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: 'home', element: <GeneralAnalytics /> },

        { path: 'dorm', element: <Dorm /> },
        { path: 'editdorm/:id', element: <EditDorm /> },
        { path: 'adddorm', element: <AddDorm /> },
        { path: 'promo', element: <Promo /> },
        { path: 'editpromo/:id', element: <EditPromo /> },
        { path: 'addpromo', element: <AddPromo /> },
        { path: 'student', element: <Student /> },
        { path: 'element', element: <Element /> },
        { path: 'editelement/:id', element: <EditElement /> },
        { path: 'viewclinic/:id', element: <ViewClinic /> },
        { path: 'viewclinicappointment/:id', element: <ViewClinicAppointment /> },
        { path: 'viewclinicprovider', element: <ClinicProvider /> },
        { path: 'profile', element: <CompanyProfile /> },
        { path: 'admin_profile', element: <AdminProfile /> },
        { path: 'addelement', element: <AddElement /> },
        { path: 'magictype', element: <Magictype /> },
        { path: 'editmagictype/:id', element: <EditMagictype /> },
        { path: 'appointmentchart/:id', element: <AppointmentChart /> },
        { path: 'cProvider/:id', element: <CProvider /> },
        { path: 'cSlot/:id', element: <CSlot /> },
        { path: 'addmagictype', element: <AddMagictype /> },
        { path: 'tag', element: <Tag /> },
        { path: 'edittag/:id', element: <EditTag /> },
        { path: 'addtag', element: <AddTag /> },
        { path: 'notification', element: <Notification /> },
        { path: 'addnotification', element: <AddNotification /> },
        { path: 'editnotification/:id', element: <EditNotification /> },
        { path: 'checkerpayment', element: <CheckerPayment /> },
        { path: 'review', element: <Review /> },
        { path: 'review/:id', element: <Creview /> },
        { path: 'rarity', element: <Rarity /> },
        { path: 'editrarity/:id', element: <EditRarity /> },
        { path: 'addrarity', element: <AddRarity /> },
        { path: 'spell', element: <Spell /> },
        { path: 'editspell/:id', element: <EditSpell /> },
        { path: 'addspell', element: <AddSpell /> },
        { path: 'editslot/:id', element: <EditSlot /> },
        { path: 'addslot', element: <AddSlot /> },
        { path: 'addslot/:id', element: <AddSlot /> },
        { path: 'slot/:id', element: <Effect /> },
        { path: 'all_slot', element: <Slot /> },
        { path: 'appointment', element: <Appointment /> },
        { path: 'todayShadow', element: <TodayShadow /> },
        { path: 'studentDetail', element: <StudentDetail /> },
        { path: 'qa/:id', element: <QA /> },
        { path: 'report/:id', element: <Report /> },
        { path: 'card', element: <Card /> },
        { path: 'editcard/:id', element: <EditCard /> },
        { path: 'addcard', element: <AddCard /> },
        { path: 'character', element: <Character /> },
        { path: 'editcharacter/:id', element: <EditCharacter /> },
        { path: 'editRegistration', element: <EditCharacter /> },
        { path: 'addcharacter', element: <AddCharacter /> },
        { path: 'CardDetail/:id', element: <Profile /> },
        { path: 'dresscode', element: <DressCode /> },
        { path: 'AddDressCode', element: <AddDressCode /> },
        { path: 'editdresscode/:id', element: <EditDressCode /> },
        { path: 'Form', element: <Form /> },
        { path: 'addForm', element: <AddForm /> },
        { path: 'editform/:id', element: <EditForms /> },
        { path: 'checkinInfo', element: <CheckinInfo /> },
        { path: 'addcheckinInfo', element: <AddCheckinInfo /> },
        { path: 'editcheckinInfo/:id', element: <EditCheckinInfo /> },



        { path: 'ecommerce', element: <GeneralEcommerce /> },

        { path: 'banking', element: <GeneralBanking /> },
        { path: 'booking', element: <GeneralBooking /> },

        {
          path: 'e-commerce',
          children: [
            { element: <Navigate to="/dashboard/e-commerce/shop" replace />, index: true },
            { path: 'shop', element: <EcommerceShop /> },
            { path: 'product/:name', element: <EcommerceProductDetails /> },
            { path: 'list', element: <EcommerceProductList /> },
            { path: 'product/new', element: <EcommerceProductCreate /> },
            { path: 'product/:name/edit', element: <EcommerceProductCreate /> },
            { path: 'checkout', element: <EcommerceCheckout /> },
          ],
        },
      ],
    },
    //   {
    //     path: 'auth',
    //     children: [
    //       {
    //         path: 'login',
    //         element: (
    //           <GuestGuard>
    //             <Login />
    //           </GuestGuard>
    //         ),
    //       },
    //       {
    //         path: 'register',
    //         element: (
    //           <GuestGuard>
    //             <Register />
    //           </GuestGuard>
    //         ),
    //       },
    //       { path: 'login-unprotected', element: <Login /> },
    //       { path: 'register-unprotected', element: <Register /> },
    //       { path: 'reset-password', element: <ResetPassword /> },
    //       { path: 'verify', element: <VerifyCode /> },
    //     ],
    //   },

    //   // Dashboard Routes
    //   {
    //     path: 'dashboard',
    //     element: (
    //       <AuthGuard>
    //         <DashboardLayout />
    //       </AuthGuard>
    //     ),
    //     children: [
    //       { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
    //       { path: 'dom', element: <Dom /> },
    //       { path: 'ecommerce', element: <GeneralEcommerce /> },
    //       { path: 'analytics', element: <GeneralAnalytics /> },
    //       { path: 'banking', element: <GeneralBanking /> },
    //       { path: 'booking', element: <GeneralBooking /> },

    // {
    //   path: 'e-commerce',
    //   children: [
    //     { element: <Navigate to="/dashboard/e-commerce/shop" replace />, index: true },
    //     { path: 'shop', element: <EcommerceShop /> },
    //     { path: 'product/:name', element: <EcommerceProductDetails /> },
    //     { path: 'list', element: <EcommerceProductList /> },
    //     { path: 'product/new', element: <EcommerceProductCreate /> },
    //     { path: 'product/:name/edit', element: <EcommerceProductCreate /> },
    //     { path: 'checkout', element: <EcommerceCheckout /> },
    //   ],
    // },
    //       {
    //         path: 'user',
    //         children: [
    //           { element: <Navigate to="/dashboard/user/profile" replace />, index: true },
    //           { path: 'profile', element: <UserProfile /> },
    //           { path: 'cards', element: <UserCards /> },
    //           { path: 'list', element: <UserList /> },
    //           { path: 'new', element: <UserCreate /> },
    //           { path: ':name/edit', element: <UserCreate /> },
    //           { path: 'account', element: <UserAccount /> },
    //         ],
    //       },
    //       {
    //         path: 'invoice',
    //         children: [
    //           { element: <Navigate to="/dashboard/invoice/list" replace />, index: true },
    //           { path: 'list', element: <InvoiceList /> },
    //           { path: ':id', element: <InvoiceDetails /> },
    //           { path: ':id/edit', element: <InvoiceEdit /> },
    //           { path: 'new', element: <InvoiceCreate /> },
    //         ],
    //       },
    // {
    //   path: 'blog',
    //   children: [
    //     { element: <Navigate to="/dashboard/blog/posts" replace />, index: true },
    //     { path: 'posts', element: <BlogPosts /> },
    //     { path: 'post/:title', element: <BlogPost /> },
    //     { path: 'new', element: <BlogNewPost /> },
    //   ],
    // },
    //       {
    //         path: 'mail',
    //         children: [
    //           { element: <Navigate to="/dashboard/mail/all" replace />, index: true },
    //           { path: 'label/:customLabel', element: <Mail /> },
    //           { path: 'label/:customLabel/:mailId', element: <Mail /> },
    //           { path: ':systemLabel', element: <Mail /> },
    //           { path: ':systemLabel/:mailId', element: <Mail /> },
    //         ],
    //       },
    //       {
    //         path: 'chat',
    //         children: [
    //           { element: <Chat />, index: true },
    //           { path: 'new', element: <Chat /> },
    //           { path: ':conversationKey', element: <Chat /> },
    //         ],
    //       },
    //       { path: 'calendar', element: <Calendar /> },
    //       { path: 'kanban', element: <Kanban /> },
    //     ],
    //   },

    //   // Main Routes
    {
      path: '*',
      element: <LogoOnlyLayout />,
      children: [
        // { path: 'coming-soon', element: <ComingSoon /> },
        // { path: 'maintenance', element: <Maintenance /> },
        // { path: 'pricing', element: <Pricing /> },
        // { path: 'payment', element: <Payment /> },
        { path: '500', element: <Page500 /> },
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" replace /> },
      ],
    },
    //   {
    //     path: '/',
    //     element: <Login/>,
    //     children: [
    //       { element: <HomePage />, index: true },
    //       { path: 'about-us', element: <About /> },
    //       { path: 'contact-us', element: <Contact /> },
    //       { path: 'faqs', element: <Faqs /> },
    //     ],
    //   },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}

// AUTHENTICATION
const Login = Loadable(lazy(() => import('../pages/auth/Login')));
const CompanyLogin = Loadable(lazy(() => import('../pages/auth/CompanyLogin')));
const ClinicLogin = Loadable(lazy(() => import('../pages/auth/ClinicLogin')));
const Register = Loadable(lazy(() => import('../pages/auth/Register')));
const ResetPassword = Loadable(lazy(() => import('../pages/auth/ResetPassword')));
const CodeMail = Loadable(lazy(() => import('../pages/auth/CodeMail')));


const Subscription = Loadable(lazy(() => import('../pages/dashboard/Subscription')));
const Home = Loadable(lazy(() => import('../pages/dashboard/Home/Home')));
const Dorm = Loadable(lazy(() => import('../pages/dashboard/Subscription/Dorm')));
const EditDorm = Loadable(lazy(() => import('../pages/dashboard/Subscription/EditDorm')));
const AddDorm = Loadable(lazy(() => import('../pages/dashboard/Subscription/AddDorm')));
const Promo = Loadable(lazy(() => import('../pages/dashboard/Promo/Promo')));
const EditPromo = Loadable(lazy(() => import('../pages/dashboard/Promo/EditPromo')));
const AddPromo = Loadable(lazy(() => import('../pages/dashboard/Promo/AddPromo')));

const Student = Loadable(lazy(() => import('../pages/dashboard/Student/Student')));
const AdminProfile = Loadable(lazy(() => import('../pages/dashboard/AdminProfile/AdminProfile')));

const Element = Loadable(lazy(() => import('../pages/dashboard/Company/Element')));
const EditElement = Loadable(lazy(() => import('../pages/dashboard/Company/EditElement')));
const ViewClinic = Loadable(lazy(() => import('../pages/dashboard/Company/CompanyClinic')));
const ClinicProvider = Loadable(lazy(() => import('../pages/dashboard/Company/clinicProvider')));
const ViewClinicAppointment = Loadable(lazy(() => import('../pages/dashboard/Company/clinicAppointment')));
const CompanyProfile = Loadable(lazy(() => import('../pages/dashboard/Company/CompanyProfile')));
const AddElement = Loadable(lazy(() => import('../pages/dashboard/Company/AddElement')));

const Magictype = Loadable(lazy(() => import('../pages/dashboard/Clinic/Magictype')));
const EditMagictype = Loadable(lazy(() => import('../pages/dashboard/Clinic/EditMagictype')));
const AddMagictype = Loadable(lazy(() => import('../pages/dashboard/Clinic/AddMagictype')));
const AppointmentChart = Loadable(lazy(() => import('../pages/dashboard/Clinic/AppointmentChart')));
const CProvider = Loadable(lazy(() => import('../pages/dashboard/Clinic/Provider')));
const CSlot = Loadable(lazy(() => import('../pages/dashboard/Clinic/Slot')));

const Tag = Loadable(lazy(() => import('../pages/dashboard/Attendence/Tag')));
const EditTag = Loadable(lazy(() => import('../pages/dashboard/Attendence/EditTag')));
const AddTag = Loadable(lazy(() => import('../pages/dashboard/Attendence/AddTag')));

const Notification = Loadable(lazy(() => import('../pages/dashboard/Notification/Notification')));
const EditNotification = Loadable(lazy(() => import('../pages/dashboard/Notification/EditNotification')));
const AddNotification = Loadable(lazy(() => import('../pages/dashboard/Notification/AddNotification')));
const CheckerPayment = Loadable(lazy(() => import('../pages/dashboard/CheckerPayment/CheckerPayment')));

const Review = Loadable(lazy(() => import('../pages/dashboard/Review/Review')));
const Creview = Loadable(lazy(() => import('../pages/dashboard/Review/Creview')));

const Rarity = Loadable(lazy(() => import('../pages/dashboard/TermCondition.js/Rarity')));
const EditRarity = Loadable(lazy(() => import('../pages/dashboard/TermCondition.js/EditRarity')));
const AddRarity = Loadable(lazy(() => import('../pages/dashboard/TermCondition.js/AddRarity')));

const Spell = Loadable(lazy(() => import('../pages/dashboard/Provider/Spell')));
const EditSpell = Loadable(lazy(() => import('../pages/dashboard/Provider/EditSpell')));
const AddSpell = Loadable(lazy(() => import('../pages/dashboard/Provider/AddSpell')));

const EditSlot = Loadable(lazy(() => import('../pages/dashboard/Slot/EditSlot')));
const AddSlot = Loadable(lazy(() => import('../pages/dashboard/Slot/AddSlot')));
const Slot = Loadable(lazy(() => import('../pages/dashboard/Slot/Slot')));
const Effect = Loadable(lazy(() => import('../pages/dashboard/Slot/Effect')));

const Appointment = Loadable(lazy(() => import('../pages/dashboard/Appointment/Appointment')));
const TodayShadow = Loadable(lazy(() => import('../pages/dashboard/TodayShadow/TodayShadow')));
const StudentDetail = Loadable(lazy(() => import('../pages/dashboard/TodayShadow/StudentDetail')));
const QA = Loadable(lazy(() => import('../pages/dashboard/Student/QA')));
const Report = Loadable(lazy(() => import('../pages/dashboard/Student/Report')));

const Card = Loadable(lazy(() => import('../pages/dashboard/Card/Card')));
const EditCard = Loadable(lazy(() => import('../pages/dashboard/Card/EditCard')));
const AddCard = Loadable(lazy(() => import('../pages/dashboard/Card/AddCard')));
// const CardDetail = Loadable(lazy(() => import('../pages/dashboard/Card/CardDetails')));
const Profile = Loadable(lazy(() => import('../pages/dashboard/Card/Profile')));
const DressCode = Loadable(lazy(() => import('../pages/dashboard/ClinicPortal/DressCode')));
const AddDressCode = Loadable(lazy(() => import('../pages/dashboard/ClinicPortal/AddDressCode')));
const EditDressCode = Loadable(lazy(() => import('../pages/dashboard/ClinicPortal/EditDressCode')));
const Form = Loadable(lazy(() => import('../pages/dashboard/ClinicPortal/Form')));
const AddForm = Loadable(lazy(() => import('../pages/dashboard/ClinicPortal/AddForm')));
const EditForms = Loadable(lazy(() => import('../pages/dashboard/ClinicPortal/EditFroms')));
const CheckinInfo = Loadable(lazy(() => import('../pages/dashboard/ClinicPortal/CheckinInfo')));
const AddCheckinInfo = Loadable(lazy(() => import('../pages/dashboard/ClinicPortal/AddCheckInfo')));
const EditCheckinInfo = Loadable(lazy(() => import('../pages/dashboard/ClinicPortal/EditCheckInfo')));

const Character = Loadable(lazy(() => import('../pages/dashboard/Registration/Registration')));
const EditCharacter = Loadable(lazy(() => import('../pages/dashboard/Registration/EditRegistration')));
const AddCharacter = Loadable(lazy(() => import('../pages/dashboard/Registration/AddRegistration')));

const GeneralEcommerce = Loadable(lazy(() => import('../pages/dashboard/GeneralEcommerce')));
// const GeneralApp = Loadable(lazy(() => import('../pages/dashboard/GeneralApp')));
const GeneralAnalytics = Loadable(lazy(() => import('../pages/dashboard/GeneralAnalytics')));
const GeneralBanking = Loadable(lazy(() => import('../pages/dashboard/GeneralBanking')));
const GeneralBooking = Loadable(lazy(() => import('../pages/dashboard/GeneralBooking')));

// ECOMMERCE
const EcommerceShop = Loadable(lazy(() => import('../pages/dashboard/EcommerceShop')));
const EcommerceProductDetails = Loadable(lazy(() => import('../pages/dashboard/EcommerceProductDetails')));
const EcommerceProductList = Loadable(lazy(() => import('../pages/dashboard/EcommerceProductList')));
const EcommerceProductCreate = Loadable(lazy(() => import('../pages/dashboard/EcommerceProductCreate')));
const EcommerceCheckout = Loadable(lazy(() => import('../pages/dashboard/EcommerceCheckout')));

// // INVOICE
// const InvoiceList = Loadable(lazy(() => import('../pages/dashboard/InvoiceList')));
// const InvoiceDetails = Loadable(lazy(() => import('../pages/dashboard/InvoiceDetails')));
// const InvoiceCreate = Loadable(lazy(() => import('../pages/dashboard/InvoiceCreate')));
// const InvoiceEdit = Loadable(lazy(() => import('../pages/dashboard/InvoiceEdit')));

// BLOG
// const BlogPosts = Loadable(lazy(() => import('../pages/dashboard/BlogPosts')));
// const BlogPost = Loadable(lazy(() => import('../pages/dashboard/BlogPost')));
// const BlogNewPost = Loadable(lazy(() => import('../pages/dashboard/BlogNewPost')));

// // USER
// const UserProfile = Loadable(lazy(() => import('../pages/dashboard/UserProfile')));
// const UserCards = Loadable(lazy(() => import('../pages/dashboard/UserCards')));
// const UserList = Loadable(lazy(() => import('../pages/dashboard/UserList')));
// const UserAccount = Loadable(lazy(() => import('../pages/dashboard/UserAccount')));
// const UserCreate = Loadable(lazy(() => import('../pages/dashboard/UserCreate')));

// // APP
// const Chat = Loadable(lazy(() => import('../pages/dashboard/Chat')));
// const Mail = Loadable(lazy(() => import('../pages/dashboard/Mail')));
// const Calendar = Loadable(lazy(() => import('../pages/dashboard/Calendar')));
// const Kanban = Loadable(lazy(() => import('../pages/dashboard/Kanban')));

// // MAIN
// const HomePage = Loadable(lazy(() => import('../pages/Home')));
// const About = Loadable(lazy(() => import('../pages/About')));
// const Contact = Loadable(lazy(() => import('../pages/Contact')));
// const Faqs = Loadable(lazy(() => import('../pages/Faqs')));
// const ComingSoon = Loadable(lazy(() => import('../pages/ComingSoon')));
// const Maintenance = Loadable(lazy(() => import('../pages/Maintenance')));
// const Pricing = Loadable(lazy(() => import('../pages/Pricing')));
// const Payment = Loadable(lazy(() => import('../pages/Payment')));
const Page500 = Loadable(lazy(() => import('../pages/Page500')));
const NotFound = Loadable(lazy(() => import('../pages/Page404')));
